import {
  TemplateOrCalculation,
  TemplateOrCalculationType,
  TemplateOrCalculationWithValue,
} from '../apis/api';
import { useMemo } from 'react';
import { isValidTemplateId } from '../lib/templates/templatesLib';
import { skipToken } from '@reduxjs/toolkit/query';
import { useTemplateOrCalculation } from './useTemplateOrCalculation';

export const createTemplateOrCalculationWithValue = (
  templateOrCalculation: TemplateOrCalculation,
): TemplateOrCalculationWithValue => {
  const hasValidValue = isValidTemplateId(templateOrCalculation.id);
  const value = hasValidValue ? templateOrCalculation : skipToken;
  return { ...templateOrCalculation, value, hasValidValue };
};

/**
 * Returns TemplateOrCalculation object, which is used in endpoints for configurations
 * Based on values inside this object, the correct endpoint will be used (rtk queries decide, if calculation or template endpoint should be used)
 * We use a map, because we want to keep object reference, so that we don't need to re-render components, which use this hook
 */
export function useTemplateOrCalculationWithValue(
  forcedType?: TemplateOrCalculationType,
): TemplateOrCalculationWithValue {
  const templateOrCalculation = useTemplateOrCalculation(forcedType);

  return useMemo(() => {
    return createTemplateOrCalculationWithValue(templateOrCalculation);
  }, [templateOrCalculation]);
}
